<template>
  <div class="point">
    <el-form
      :inline="true"
      label-position="left"
      class="demo-form-inline"
      :model="form"
    >
      <el-form-item label="">
        <el-select
          filterable
          placeholder="所属社区"
          clearable
          style="width: 144px"
          v-model="form.deptCode"
        >
          <el-option
            v-for="item in commcommunityList"
            :key="item.code"
            :label="item.pointName"
            :value="item.deptCode"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="">
        <el-input
          v-model="form.pointName"
          clearable
          placeholder="请输入点位名称"
          style="width: 428px"
        >
          <el-button
            style="background: #0495ff; border-radius: 0px 4px 4px 0px; color: #ffffff"
            slot="append"
            icon="el-icon-search"
            @click="getPointLevelListPageFun"
          ></el-button>
        </el-input>
      </el-form-item>
    </el-form>
    <div class="table-top-btns">
      <div class="left-btn">
        <div class="select-number">
          当前选中
          <span style="color: #3666ea">{{ selectedIdOptions.length }}</span>
          条
        </div>
      </div>
    </div>
    <div ref="refssss">
      <common-table
        :select="true"
        :isShowPagination="false"
        :dataList="dataList"
        :selectedIdOptions="selectedIdOptions"
        :maxHeight="380"
        @handleSelectionChange="handleSelectionChange"
        @selectAll="selectAll"
      >
        <template v-slot:pointTypes="{ scope }">
          <span>{{ getPointTypeName(scope.row.pointTypes) }}</span>
        </template>
      </common-table>
    </div>
  </div>
</template>

<script>
import commonTable from "@/components/table/index.vue";
import pageChangeSelect from "@/mixins/page-change-select.js";
import { getPointLevelListPage, getCommcommunityAll } from "@/api/point.js";
export default {
  components: {
    commonTable
  },
  props: {
    pointInfo: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  mixins: [pageChangeSelect],
  data() {
    return {
      communityCode: "",
      form: {
        pointName: "",
        pointType: "",
        deptCode: ""
      },
      commcommunityList: [],
      dataList: {
        tableData: [],
        columns: [
          {
            prop: "pointName",
            label: "点位名称"
          },
          {
            prop: "levelName2",
            label: "所属社区"
          }
        ]
      },
      page: {
        size: 10,
        page: 1,
        total: 0
      }
    };
  },
  mounted() {
    this.selectedIdOptions = this.pointInfo.selectedIdOptions || [];
    let detpCode =
      JSON.parse(sessionStorage.getItem("userInfo")) &&
      JSON.parse(sessionStorage.getItem("userInfo")).detpCode;
    if (detpCode && detpCode.length >= 12) {
      this.getCommcommunityAllFun(detpCode);
    }
  },
  methods: {
    // 社区列表
    async getCommcommunityAllFun(detpCode) {
      const res = await getCommcommunityAll();
      let code = detpCode.slice(0, 12);
      this.commcommunityList =
        res.data.data.filter(item => item.deptCode == code) || [];
      this.form.deptCode = this.commcommunityList.length
        ? this.commcommunityList[0].deptCode
        : "";
      this.getPointLevelListPageFun();
    },
    nextStepsFun() {
      let pointInfo = {
        selectedOptions: [],
        selectedIdOptions: []
      };
      if (!this.selectedOptions.length) {
        this.$message({
          type: "error",
          message: "请先选择点位"
        });
        return;
      }
      pointInfo.selectedOptions = this.selectedOptions.map(item => {
        return {
          pointName: item.pointName,
          pointTypes: item.pointTypes,
          communityCode: item.communityCode,
          blockCode: item.blockCode,
          levelName2: item.levelName2,
          levelName3: item.levelName3,
          pointLevelId: item.id
        };
      });
      pointInfo.selectedIdOptions = this.selectedIdOptions;
      this.$emit("updatePointsData", pointInfo);
    },
    // 分页查询
    async getPointLevelListPageFun() {
      let params = {
        page: 1,
        size: 99999,
        levelCode: 3,
        ...this.form
      };
      const res = await getPointLevelListPage(params);
      if (res.data.code == 200) {
        this.dataList.tableData = res.data.data.records
          ? res.data.data.records
          : [];
        if (this.selectedIdOptions.length) {
          this.echo();
        }
      }
    },
    echo() {
      let that = this;
      that.$nextTick(() => {
        that.dataList.tableData.forEach(row => {
          if (that.selectedIdOptions && that.selectedIdOptions.length !== 0) {
            if (that.selectedIdOptions.includes(row.id)) {
              that.$children[1].$refs.multipleTable.toggleRowSelection(
                row,
                true
              );
            }
          }
        });
      });
    }
  },
  computed: {},
  watch: {}
};
</script>

<style scoped lang="less">
@import "~@/components/less.less";
.point {
  height: 100%;
  width: 100%;
  position: relative;
}
</style>



// WEBPACK FOOTER //
// src/pages/task/customTask/components/point.vue